var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    _storedProcedureResultTypes: {
        DataSet: '0',
        Empty: '1'
    },
    
    StoredProcedureBrickModel: function (opts) {
        var form = opts.form
            , meta = Operator.Layout.getBlockMeta(form.find('#BrickId').val())
            , procedureDropdown = form.find('#ProcedureName')
            , resultPathContainer = form.find('.result-path-container')
            , outputContainer = form.find('.output-container')
            , returnContainer = form.find('.return-container');
        
        form.find('#ResultType').on('change', function(){
            var selectedValue = $(this).val();
            
            if(selectedValue === Operator.blockEditors._storedProcedureResultTypes.DataSet){
                resultPathContainer.show();
                outputContainer.show();
                returnContainer.hide();
            } else{
                resultPathContainer.hide();
                outputContainer.hide();
                returnContainer.show();
            }
        }).trigger('change');

        var sortedStoredProcedureNames = _.sortBy(_.map(meta.AllowedProcedures, 'Name'));

        procedureDropdown.html(
            $(MDB.objectToDropdown(sortedStoredProcedureNames)).html()
        ).val(procedureDropdown.data('selected'));
        
        Operator.Layout.setupCollections(form, _.noop);
    }
});